const goodsApiList = {
  goodsSelection: "/manage/goods/goods/choose",
  goodsList: "/manage/goods/goods/list",
  selectionGoodsList: "/manage/goods/goods/listAll",
  goodsDelete: "/manage/goods/goods/delete",
  editGoods: "/manage/goods/goods/get?id=",
  updateGoods: "/manage/goods/goods/update",
  updateStock: "/manage/goods/goods/updateStock",
  // updateNewPrice: '/manage/goods/goods/updateNewPrice',
  updateNewPrice: "/v2/web/goods/applyPriceExamine",
  batchEnable: "/manage/goods/goods/batchEnable",
  onoffShop: "/manage/shop/shop/onoffShop",
  importData: "/v2/web/goods/batchImportPriceOrStock",
  importCodeData: "/v3/internal/goods/batchImportSelfCode", // 紧固件下商品编码
  importList: "/manage/goods/goods/getStockAndPriceTaskList",
  exportStockData: "/manage/goods/goods/downloadStock", // 导出库存
  exportGoodsSelect: "/manage/goods/goods/downloadGoodsSelect", // 导出商品选品
  exportGoodsManage: "/manage/goods/goods/downloadgoodsManage", // 导出商品管理
  updateStoragePos: "/manage/goods/goods/updateStoragePos", // 更新库位信息
  getStockCountList: "/v2/web/goods/getStockCountList", // 更新库位信息
  exportdata: "/system/goods/exportdata", // 导出
  postGoodsCancel: "/manage/goods/goods/importGoodsSelectCancel" // 导出
};
export default goodsApiList;



// WEBPACK FOOTER //
// ./src/service/basic/goodsApiList.js